export const FORM_ID = "edit-liability";

/** Sits under the linked Start date / Term / End date group. */
export const LINKED_DATES_HINT =
  "Term and end date are linked, a change in one forces an update in the other.";

/** Warns that schedule-affecting edits recompute the amortization plan. */
export const RECOMPUTE_NOTE =
  "Changing the amount borrowed, start date or term can affect the existing accuracy of every payment's principal / interest split.";
